import { FlowContextProvider, StepWrapper, useReturnToPath } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';
import { Route, Routes, useMatch } from 'react-router-dom';

import { ContactAdvisorStep } from './steps/ContactAdvisorStep';
import { TermsAndAgreementsStep } from './steps/TermsAndAgreementsStep';
import { UpdateUserLevelSettingsStep } from './steps/UpdateUserLevelSettingsStep';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { urlBuilder } from '../Shared/urlBuilder';

export default function Controller() {
  const match = useMatch(`${urlBuilder.appEditUserLevelSettings()}/*`);
  const returnToPath = useReturnToPath(urlBuilder.getLegalAccounts.absolute());

  return (
    <ErrorBoundary>
      <IdempotencyProviderWithFeatureRegistry featureName="editUserLevelSettings">
        <FlowContextProvider basePath={match!.pathnameBase} routePath="" returnToPath={returnToPath}>
          <Routes>
            <Route
              data-feature="edit_user_level_settings"
              path="/update_settings"
              element={
                <StepWrapper name="update_settings">
                  {stepProps => <UpdateUserLevelSettingsStep {...stepProps} />}
                </StepWrapper>
              }
            />
            <Route
              data-feature="edit_user_level_settings"
              path="/terms_and_agreements"
              element={
                <StepWrapper name="terms_and_agreements">
                  {stepProps => <TermsAndAgreementsStep {...stepProps} />}
                </StepWrapper>
              }
            />
            <Route
              data-feature="edit_user_level_settings"
              path="/contact_advisor"
              element={
                <StepWrapper name="contact_advisor">{stepProps => <ContactAdvisorStep {...stepProps} />}</StepWrapper>
              }
            />
          </Routes>
        </FlowContextProvider>
      </IdempotencyProviderWithFeatureRegistry>
    </ErrorBoundary>
  );
}
